var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUniversityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 22.667,
    viewBox: "0 0 17 22.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "building-solid",
    d: "M2.125,0A2.126,2.126,0,0,0,0,2.125V20.542a2.126,2.126,0,0,0,2.125,2.125h4.25V19.125a2.125,2.125,0,0,1,4.25,0v3.542h4.25A2.126,2.126,0,0,0,17,20.542V2.125A2.126,2.126,0,0,0,14.875,0Zm.708,10.625a.71.71,0,0,1,.708-.708H4.958a.71.71,0,0,1,.708.708v1.417a.71.71,0,0,1-.708.708H3.542a.71.71,0,0,1-.708-.708Zm4.958-.708H9.208a.71.71,0,0,1,.708.708v1.417a.71.71,0,0,1-.708.708H7.792a.71.71,0,0,1-.708-.708V10.625A.71.71,0,0,1,7.792,9.917Zm3.542.708a.71.71,0,0,1,.708-.708h1.417a.71.71,0,0,1,.708.708v1.417a.71.71,0,0,1-.708.708H12.042a.71.71,0,0,1-.708-.708ZM3.542,4.25H4.958a.71.71,0,0,1,.708.708V6.375a.71.71,0,0,1-.708.708H3.542a.71.71,0,0,1-.708-.708V4.958A.71.71,0,0,1,3.542,4.25Zm3.542.708a.71.71,0,0,1,.708-.708H9.208a.71.71,0,0,1,.708.708V6.375a.71.71,0,0,1-.708.708H7.792a.71.71,0,0,1-.708-.708Zm4.958-.708h1.417a.71.71,0,0,1,.708.708V6.375a.71.71,0,0,1-.708.708H12.042a.71.71,0,0,1-.708-.708V4.958A.71.71,0,0,1,12.042,4.25Z",
    fill: "#c9c9c9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityIcon);
export default __webpack_public_path__ + "static/media/university-icon.52c2e313fedf3bcfc72bb74d909c0b7f.svg";
export { ForwardRef as ReactComponent };